// frontend/src/pages/NotFound.jsx
// The catch-all route (App.js: path="*").
//
// This file used to export a RegisterForm — a full signup form — so every
// mistyped URL and every broken in-app link dropped the user onto a
// registration screen instead of a 404. Logged-in users had no idea what had
// happened to them.

import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Where "back to safety" points depends on who is asking.
const HOME_BY_ROLE = {
  admin: '/admin/dashboard',
  'car owner': '/dashboard',
  'car workshop': '/workshop',
  'spare parts supplier': '/supplier',
  'insurance company': '/insurance',
  'vehicle loader': '/loader',
};

export default function NotFound() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();

  const home = HOME_BY_ROLE[String(user?.role || '').toLowerCase()] || '/';

  return (
    <div className="min-h-screen bg-[#0D0C0B] text-[#F4F1EA] font-['IBM_Plex_Sans',system-ui,sans-serif] antialiased
                    flex items-center justify-center px-6 py-16">
      <div className="w-full max-w-[460px] rounded-2xl border border-[#241F1B]
                      bg-gradient-to-b from-[#17140F] to-[#131110] p-8 text-center">
        <p className="font-['Space_Grotesk',sans-serif] text-[52px] leading-none font-semibold
                      tracking-[-.03em] tabular-nums text-[#DFA23C]">
          404
        </p>

        <h1 className="font-['Space_Grotesk',sans-serif] text-[19px] font-semibold tracking-[-.015em] mt-4">
          Page introuvable
        </h1>

        <p className="text-[13px] text-[#8F877B] mt-2 leading-relaxed">
          Cette adresse ne correspond à aucune page de 1PARC.
        </p>

        <p className="mt-4 px-3 py-2 rounded-lg bg-[#0F0D0C] border border-[#241F1B]
                      text-[11.5px] text-[#6E665C] break-all">
          {pathname}
        </p>

        <div className="flex flex-wrap justify-center gap-2.5 mt-7">
          <button
            onClick={() => navigate(-1)}
            className="h-[34px] px-3.5 rounded-[9px] border border-[#2B2724] hover:border-[#4E4740]
                       bg-[#141210] text-[12.5px] font-medium text-[#C9C3B6] hover:text-[#F4F1EA] transition-colors"
          >
            Retour
          </button>
          <Link
            to={home}
            className="h-[34px] px-3.5 rounded-[9px] bg-gradient-to-b from-[#F4F1EA] to-[#CFCAC0]
                       hover:from-white hover:to-[#DED9CE] text-[#141210] text-[12.5px] font-semibold
                       flex items-center transition-colors"
          >
            {user ? 'Retour au tableau de bord' : "Aller à l'accueil"}
          </Link>
        </div>
      </div>
    </div>
  );
}
